import styled from 'styled-components';
import Parent from './style';
const Wrapper = styled(Parent)``;

export default Wrapper;
